import {Injectable} from '@angular/core';
import {Response, Headers, RequestOptions, ResponseContentType} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class ApplicantService {

  private url: string = `${ environment.apiRoot }/applicant/`;
  private urlContract: string = `${ environment.apiRoot }/applicant-contract/`;
  private urlPDF: string = `${ environment.apiRoot }/pdf/`;
  private urlResumePDF: string = `${ environment.apiRoot }/resume/`;

  constructor(private http: HttpAuth) { }

  public getApplicantCV (user_id): Observable<any> {
    return this.http.get(this.urlPDF+"?user_id="+user_id, {responseType: ResponseContentType.Blob})
      .map(
          res=>new Blob ([res.blob()], {type: res.headers.get('Content-Type')})
        )
      .catch(this.handleError);
  }

  public getApplicantResume (user_id): Observable<any> {
    return this.http.get(this.urlResumePDF+"?user_id="+user_id, {responseType: ResponseContentType.Blob})
      .map(
          res=>new Blob ([res.blob()], {type: res.headers.get('Content-Type')})
        )
      .catch(this.handleError);
  }

  public putApplicantFavorite(job_id, user_id, favorite): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    const body = {job_id:job_id, user_id:user_id, favorite:favorite}

    return this.http.put(this.url,body,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putApplicantRequestDocList(user_id, job_id): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    const body = {job_id:job_id, user_id:user_id, requestdoc: '1'}

    return this.http.put(this.url,body,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }


  public putApplicantStatus(job_id, user_id, status, feedback?): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });
    let body = {};
    if (feedback != null && feedback == 1){
       body = {job_id:job_id, user_id:user_id, status:status, feedback:'0'}
    }else{
       body = {job_id:job_id, user_id:user_id, status:status}
    }

    return this.http.put(this.url,body,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putApplicantContract(job_id, user_id, status, feedback?): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });
    let body = {};
    if (feedback != null && feedback == 1){
       body = {job_id:job_id, user_id:user_id, status:status, feedback:'0'}
    }else{
       body = {job_id:job_id, user_id:user_id, status:status}
    }

    return this.http.put(this.urlContract,body,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/applicant.service.ts